@if (toasts$ | async; as toasts) {
  <div class="progressive-toasts">
    @for (toast of toasts; track toast.id) {
      <app-progress-toasts-item [toast]="toast"></app-progress-toasts-item>
    }
  </div>
}
